/**
 * Cycling status messages shown during a scan.
 * Shared between NewScan.jsx and Prospecting.jsx.
 * Each message is shown for ~8 seconds before advancing.
 */
export const SCAN_STATUSES = [
  'Fetching business data...',
  'Finding local competitors...',
  'Running ChatGPT visibility scan...',
  'Running Gemini visibility scan...',
  'Scoring your AI presence...',
  'Generating AI report...',
];
